import React, { ClipboardEventHandler, PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum ContentParagraphModifier {
  MARGIN_BOTTOM = 'margin-bottom',
  PADDING = 'padding',
  TOP_HEADLINE = 'top-headline',
  BOLD = 'bold',
}

type ContentParagraphProps = PropsWithChildren<{
  modifier?: Modifier<ContentParagraphModifier>;
  onCopy?: ClipboardEventHandler<HTMLParagraphElement>;
}>;

export function ContentParagraph({ children, modifier, onCopy }: ContentParagraphProps) {
  if (children) {
    return (
      <p className={bem('content-paragraph', modifier)} onCopy={onCopy}>
        {children}
      </p>
    );
  }

  return null;
}
